import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import UserNetwork from "./UserNetwork";
import UserCard from "./UserCard";

export default function Board() {
    const location = useLocation();
    const [showMenu, setShowMenu] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showVerify, setShowVerify] = useState(false);
    const [showPurple, setShowPurple] = useState(false);

    const handlePurple = () => {
        setShowPurple(true);
        setShowModal(false);
    };

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.replace('#', ''));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);

    return (
        <>
            <div id='top' className="bg-white text-gray-900" style={{ fontFamily: 'Inter, sans-serif' }}>
                <header className="flex items-center justify-between px-6 md:px-20 py-6 border-solid border-b border-gray-200">
                    <div className="flex items-center space-x-2">
                        <img alt="Cartoon bear icon" className="w-6 h-6" height="24"
                            src="https://c.animaapp.com/VPWnEuWR/img/file--4--1@2x.png" width="24" />
                        <span className="font-semibold text-blue-600 text-sm md:text-base">
                            Moodeng Credit
                        </span>
                        <div className="hidden md:block border-solid border-l border-gray-300 h-5 ml-4">
                        </div>
                        <nav className="hidden md:flex space-x-8 text-xs md:text-sm font-normal text-black">
                            <a className="hover:underline" href="#">
                                Features
                            </a>
                            <a className="hover:underline" href="#">
                                Why Lend?
                            </a>
                            <a className="hover:underline" href="#">
                                Benefits
                            </a>
                            <a className="hover:underline" href="#">
                                Doc's
                            </a>
                        </nav>
                    </div>
                    <div className="flex items-center space-x-4">
                        <button aria-label="Notifications"
                            className="bg-blue-600 text-white px-3 py-2 rounded-full z-[2] hover:bg-blue-700 transition">
                            <i className="fas fa-bell">
                            </i>
                        </button>
                        <button aria-label="User profile"
                            onClick={() => setShowMenu(!showMenu)}
                            className="bg-blue-600 text-white px-3 py-2 rounded-full z-[2] hover:bg-blue-700 transition">
                            <i className="fas fa-user">
                            </i>
                        </button>
                        {showMenu && <UserNetwork />}
                    </div>
                </header>
                <main className="mx-auto px-6 pt-6 pb-20 md:px-20">
                    <h1 className="text-xl md:text-2xl font-semibold text-gray-900 mb-1">
                        Request Board for Microloans
                    </h1>
                    <p className="text-xs md:text-sm text-gray-700 mb-6">
                        Browse requests posted on Moodeng, or jump right in and get verified to start borrowing.
                    </p>
                    <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 mb-10">
                        <button
                            onClick={() => setShowModal(true)}
                            className="bg-blue-600 text-white text-xs md:text-sm font-semibold px-5 py-2 rounded-md w-full sm:w-auto hover:bg-blue-700 transition">
                            APPLY LOAN
                        </button>
                        <a onClick={() => setShowVerify(true)} className="flex items-center text-blue-600 text-xs md:text-sm font-normal mt-4 sm:mt-0 space-x-1" href="#">
                            <i className="fas fa-play-circle">
                            </i>
                            <span>
                                Credit Levelling Guide!
                            </span>
                        </a>
                    </div>
                    <div className="flex flex-col md:flex-row md:space-x-10">
                        <aside className="w-full md:w-64 flex-shrink-0">
                            <h2 className="font-semibold text-gray-900 text-sm mb-4">
                                Filters
                            </h2>
                            <form className="space-y-6 text-xs md:text-sm text-gray-700">
                                <fieldset>
                                    <legend className="font-semibold mb-2">
                                        Set Lending Limit
                                    </legend>
                                    <input className="w-full border border-gray-300 rounded px-2 py-1 mb-3 text-xs md:text-sm"
                                        placeholder="Custom Amount" type="text" />
                                    <div className="space-y-1">
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="lending-limit" type="radio" value="150" />
                                            <span>
                                                $150
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="lending-limit" type="radio" value="80" />
                                            <span>
                                                $80
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="lending-limit" type="radio" value="40" />
                                            <span>
                                                $40
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="lending-limit" type="radio" value="15" />
                                            <span>
                                                $15
                                            </span>
                                        </label>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend className="font-semibold mb-2">
                                        Repayment Amount
                                    </legend>
                                    <input className="w-full border border-gray-300 rounded px-2 py-1 mb-3 text-xs md:text-sm"
                                        placeholder="Custom Amount" type="text" />
                                    <div className="space-y-1">
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="repayment-amount" type="radio"
                                                value="0-5" />
                                            <span>
                                                0% to 5%
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="repayment-amount" type="radio"
                                                value="5-10" />
                                            <span>
                                                5% to 10%
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="repayment-amount" type="radio"
                                                value="10-20" />
                                            <span>
                                                10% to 20%
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="repayment-amount" type="radio"
                                                value="20+" />
                                            <span>
                                                20%+
                                            </span>
                                        </label>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend className="font-semibold mb-2">
                                        Repayment Date
                                    </legend>
                                    <input className="w-full border border-gray-300 rounded px-2 py-1 mb-3 text-xs md:text-sm"
                                        placeholder="Pick a date..." type="date" />
                                    <div className="space-y-1">
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="repayment-date" type="radio"
                                                value="next-week" />
                                            <span>
                                                Next Week
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="repayment-date" type="radio"
                                                value="next-30-days" />
                                            <span>
                                                Next 30 Days
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="repayment-date" type="radio"
                                                value="next-90-days" />
                                            <span>
                                                Next 90 Days
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-radio text-blue-600" name="repayment-date" type="radio"
                                                value="next-120-days" />
                                            <span>
                                                Next 120 Days+
                                            </span>
                                        </label>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend className="font-semibold mb-2">
                                        Borrow Type
                                    </legend>
                                    <div className="space-y-1 text-xs md:text-sm text-gray-700">
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-checkbox text-blue-600" name="borrow-type" type="checkbox"
                                                value="good-standing" />
                                            <span>
                                                Good Standing
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-checkbox text-blue-600" name="borrow-type" type="checkbox"
                                                value="beginner" />
                                            <span>
                                                Beginner Borrower
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-checkbox text-blue-600" name="borrow-type" type="checkbox"
                                                value="no-active" />
                                            <span>
                                                No Active Loans
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-checkbox text-blue-600" name="borrow-type" type="checkbox"
                                                value="long-term" />
                                            <span>
                                                Long Term Loans
                                            </span>
                                        </label>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend className="font-semibold mb-2">
                                        Network
                                    </legend>
                                    <div className="space-y-1 text-xs md:text-sm text-gray-700">
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-checkbox text-blue-600" name="network" type="checkbox"
                                                value="solana" />
                                            <span>
                                                Solana
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-checkbox text-blue-600" name="network" type="checkbox" value="op" />
                                            <span>
                                                OP
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-checkbox text-blue-600" name="network" type="checkbox" value="arb" />
                                            <span>
                                                Arb
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-checkbox text-blue-600" name="network" type="checkbox"
                                                value="polygon" />
                                            <span>
                                                Polygon
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-checkbox text-blue-600" name="network" type="checkbox"
                                                value="base" />
                                            <span>
                                                Base
                                            </span>
                                        </label>
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input className="form-checkbox text-blue-600" name="network" type="checkbox"
                                                value="binance" />
                                            <span>
                                                Binance
                                            </span>
                                        </label>
                                    </div>
                                    <p className="text-gray-400 text-[9px] mt-1">
                                        More Networks...
                                    </p>
                                </fieldset>
                            </form>
                        </aside>
                        <section className="flex-1 flex flex-col items-center mt-10 md:mt-0">
                            <div className="flex flex-wrap justify-start md:justify-end gap-3 mb-6 w-full max-w-xl">
                                <button
                                    className="text-[10px] md:text-xs border border-gray-300 rounded px-3 py-1 flex items-center space-x-1 hover:bg-gray-100">
                                    <span>
                                        Lowest
                                    </span>
                                    <i className="fas fa-filter text-gray-600 text-xs">
                                    </i>
                                </button>
                                <button
                                    className="text-[10px] md:text-xs border border-gray-300 rounded px-3 py-1 flex items-center space-x-1 hover:bg-gray-100">
                                    <span>
                                        Latest
                                    </span>
                                    <i className="fas fa-filter text-gray-600 text-xs">
                                    </i>
                                </button>
                                <button
                                    className="text-[10px] md:text-xs border border-gray-300 rounded px-3 py-1 flex items-center space-x-1 hover:bg-gray-100">
                                    <span>
                                        Tags
                                    </span>
                                    <i className="fas fa-filter text-gray-600 text-xs">
                                    </i>
                                </button>
                                <div className="flex-1 min-w-[180px] max-w-xs">
                                    <input
                                        className="w-full border border-gray-300 rounded-full px-4 py-1 text-xs md:text-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-600"
                                        placeholder="Search Request..." type="search" />
                                </div>
                            </div>
                            <div class="flex flex-wrap justify-center gap-6">
                                <UserCard block="optimism" />
                                <UserCard block="solana" />
                                <UserCard block="base" />
                                <UserCard block="arbitrum" />
                                <UserCard block="polygon" />
                                <UserCard block="binance" />
                            </div>
                            <button
                                className="bg-blue-600 text-white text-xs md:text-sm font-semibold px-10 py-2 mt-6 rounded-md hover:bg-blue-700 transition">
                                Load More...
                            </button>
                        </section>
                    </div>
                    <Link to="/board#top" className="float-right"><img
                        src="https://cdn.builder.io/api/v1/image/assets/c9a8899718394d87a40cf9e7196a9f95/e81253cfc6443f8a9fc2246506d2c6496689513b?placeholderIfAbsent=true"
                        className="w-[46px]"
                        alt="Floating action button"
                    /></Link>
                </main>
                <footer className="bg-[#0A1236] text-gray-300 pt-16 pb-8 px-6 md:px-20">
                    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
                        <div>
                            <h3 className="font-semibold text-xs mb-4 text-gray-300">
                                Product
                            </h3>
                            <ul className="space-y-2 text-[10px] md:text-xs">
                                <li>
                                    <a className="hover:underline" href="#">
                                        Features
                                    </a>
                                </li>
                                <li>
                                    <a className="hover:underline" href="#">
                                        Why Lend?
                                    </a>
                                </li>
                                <li>
                                    <a className="hover:underline" href="#">
                                        Dashboard
                                    </a>
                                </li>
                                <li>
                                    <a className="hover:underline" href="#">
                                        Guide
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="font-semibold text-xs mb-4 text-gray-300">
                                Information
                            </h3>
                            <ul className="space-y-2 text-[10px] md:text-xs">
                                <li>
                                    <a className="hover:underline" href="#">
                                        Docs
                                    </a>
                                </li>
                                <li>
                                    <a className="hover:underline" href="#">
                                        FAQs
                                    </a>
                                </li>
                                <li>
                                    <a className="hover:underline" href="#">
                                        Support
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="font-semibold text-xs mb-4 text-gray-300">
                                Company
                            </h3>
                            <ul className="space-y-2 text-[10px] md:text-xs">
                                <li>
                                    <a className="hover:underline" href="#">
                                        About us
                                    </a>
                                </li>
                                <li>
                                    <a className="hover:underline" href="#">
                                        Blogs
                                    </a>
                                </li>
                                <li>
                                    <a className="hover:underline" href="#">
                                        Contact us
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="bg-[#1E2749] p-6 rounded-md max-w-xs text-[9px] md:text-[10px]">
                            <h3 className="font-semibold text-gray-300 mb-3">
                                Get the latest updates!
                            </h3>
                            <form className="flex space-x-2 mb-3" onsubmit="event.preventDefault()">
                                <input className="w-full flex-1 rounded px-3 py-2 text-xs md:text-sm text-gray-900"
                                    placeholder="your@email.com" required="" type="email" />
                                <button aria-label="Subscribe"
                                    className="bg-blue-600 hover:bg-blue-700 transition text-white px-3 py-2 rounded" type="submit">
                                    <i className="fas fa-arrow-right">
                                    </i>
                                </button>
                            </form>
                            <p className="text-gray-400 leading-tight">
                                Hello, we are Moodeng. We created a new kind of Lender to Borrower experience. No Escrow and No
                                Middle-man. Borrow and Lend from
                                <em>
                                    Each other.
                                </em>
                            </p>
                        </div>
                    </div>
                    <div
                        className="mt-16 border-solid border-t border-gray-700 pt-6 flex flex-col md:flex-row items-center justify-between text-[9px] md:text-[10px] text-gray-400">
                        <div className="flex items-center space-x-2 mb-4 md:mb-0">
                            <img alt="Cartoon bear icon" className="w-6 h-6" height="24"
                                src="https://c.animaapp.com/VPWnEuWR/img/file--4--1@2x.png"
                                width="24" />
                            <span className="font-semibold text-white text-xs">
                                Moodeng Credit
                            </span>
                        </div>
                        <div className="flex items-center space-x-6">
                            <a className="hover:underline" href="#">
                                Terms
                            </a>
                            <a className="hover:underline" href="#">
                                Privacy
                            </a>
                            <a className="hover:underline" href="#">
                                Cookies
                            </a>
                        </div>
                        <div className="flex items-center space-x-4 mt-4 md:mt-0">
                            <a aria-label="LinkedIn" className="hover:text-white" href="#">
                                <i className="fab fa-linkedin-in text-sm">
                                </i>
                            </a>
                            <a aria-label="Facebook" className="hover:text-white" href="#">
                                <i className="fab fa-facebook-f text-sm">
                                </i>
                            </a>
                            <a aria-label="Twitter" className="hover:text-white" href="#">
                                <i className="fab fa-twitter text-sm">
                                </i>
                            </a>
                        </div>
                    </div>
                </footer>
            </div>
            {showModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <button onClick={() => setShowModal(false)} className="text-gray-600 hover:text-gray-800 fixed top-4 right-4 z-50">
                    ✖
                </button>
                <section className="bg-white rounded-2xl shadow-md max-w-md mx-auto flex flex-col" style={{minWidth: "320px"}}>
                    <header className="bg-[#1E56FF] rounded-t-2xl px-6 py-4 flex items-center justify-center gap-2">
                        <h2 className="text-white font-extrabold text-lg leading-6">
                            Set Your Own Terms
                        </h2>
                        <button aria-label="Help info" className="text-white text-sm font-semibold focus:outline-none" type="button">
                            <i className="fas fa-question-circle">
                            </i>
                        </button>
                    </header>
                    <form className="p-6 flex flex-col gap-5 text-gray-800 text-sm font-semibold">
                        <div className="flex justify-between items-center">
                            <label className="text-gray-800 font-semibold text-sm" for="borrow-amount">
                                Borrow Amount
                            </label>
                            <div className="flex items-center gap-1 bg-[#E6E9FF] text-[#1E56FF] text-xs font-semibold rounded-md px-2 py-1 select-none">
                                <button aria-label="Limit info" className="focus:outline-none" type="button">
                                    <i className="fas fa-question-circle">
                                    </i>
                                </button>
                                <span>
                                    Limit: $15.00
                                </span>
                            </div>
                        </div>
                        <div className="flex border-solid border border-gray-300 rounded-md overflow-hidden">
                            <span aria-hidden="true" className="flex items-center justify-center bg-[#E6E9FF] text-[#1E56FF] px-4 text-base">
                                <i className="fas fa-dollar-sign">
                                </i>
                                USD
                            </span>
                            <input className="flex-1 px-4 py-2 text-gray-700 text-sm font-normal focus:outline-none" id="borrow-amount" placeholder="Set your desired amount" type="text" />
                        </div>
                        <label className="font-semibold text-gray-800 text-sm" for="repayment-amount">
                            Set Repayment Amount
                        </label>
                        <input className="border border-gray-300 rounded-md px-4 py-2 text-gray-700 text-sm font-normal focus:outline-none" id="repayment-amount" placeholder="Must be more than Borrowed Amount..." type="text" />
                        <label className="font-semibold text-gray-800 text-sm">
                            Repayment Date
                        </label>
                        <div className="flex gap-3">
                            <button className="bg-[#D6E1FF] text-[#1E56FF] font-semibold rounded-md px-5 py-2 text-sm select-none" type="button">
                                5 Days
                            </button>
                            <input className="flex-1 border border-gray-300 rounded-md px-4 py-2 text-gray-700 text-sm font-normal focus:outline-none" placeholder="DD/MM/YY" type="text" />
                            <button aria-label="Calendar" className="flex items-center justify-center border border-gray-300 rounded-md px-3 text-gray-700" type="button">
                                <i className="far fa-calendar-alt">
                                </i>
                            </button>
                        </div>
                        <label className="font-semibold text-gray-800 text-sm" for="reason">
                            Reason for Borrowing
                        </label>
                        <textarea className="border border-gray-300 rounded-md px-4 py-2 text-gray-700 text-sm font-normal resize-none focus:outline-none" id="reason" maxlength="40" placeholder="My car broke down I need help..." rows="4"></textarea>
                        <div className="text-right text-xs text-gray-400 font-normal select-none">
                            0 / 40
                        </div>
                        <button onClick={() => handlePurple()} className="bg-[#1E56FF] text-white font-extrabold text-sm rounded-md py-3 mt-2 w-full" type="submit">
                            Make Your Request
                        </button>
                    </form>
                </section>
            </div>}
            {showVerify && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <button onClick={() => setShowVerify(false)} className="text-gray-600 hover:text-gray-800 fixed top-4 right-4 z-50">
                    ✖
                </button>
                <section className="bg-white rounded-2xl shadow-md max-w-md mx-auto flex flex-col" style={{minWidth: "320px"}}>
                    <header className="bg-[#1E56FF] rounded-t-2xl px-6 py-4 flex items-center justify-center gap-2">
                        <h2 className="text-white font-extrabold text-lg leading-6">
                            Set Your Own Terms
                        </h2>
                        <button aria-label="Help info" className="text-white text-sm font-semibold focus:outline-none" type="button">
                            <i className="fas fa-question-circle">
                            </i>
                        </button>
                    </header>
                    <div className="bg-[#FFD7DD] text-[#D94A5B] text-sm font-semibold flex items-center justify-between px-4 py-2 rounded-t-none rounded-b-md select-none">
                        <div className="flex items-center gap-2">
                            <i className="fas fa-id-card">
                            </i>
                            <span>
                                Verification Required for Borrowers
                            </span>
                        </div>
                        <button className="bg-[#FF5A6E] text-white text-xs font-extrabold rounded-md px-3 py-1" type="button">
                            VERIFY
                        </button>
                    </div>
                    <form className="p-6 flex flex-col gap-5 text-gray-800 text-sm font-semibold">
                        <div className="flex justify-between items-center">
                            <label className="text-gray-800 font-semibold text-sm" for="borrow-amount-2">
                                Borrow Amount
                            </label>
                            <div className="flex items-center gap-1 bg-[#E6E9FF] text-[#1E56FF] text-xs font-semibold rounded-md px-2 py-1 select-none">
                                <button aria-label="Limit info" className="focus:outline-none" type="button">
                                    <i className="fas fa-question-circle">
                                    </i>
                                </button>
                                <span>
                                    Limit: $15.00
                                </span>
                            </div>
                        </div>
                        <div className="flex border-solid border border-gray-300 rounded-md overflow-hidden">
                            <span aria-hidden="true" className="flex items-center justify-center bg-[#E6E9FF] text-[#1E56FF] px-4 text-base">
                                <i className="fas fa-dollar-sign">
                                </i>
                                USD
                            </span>
                            <input className="flex-1 px-4 py-2 text-gray-700 text-sm font-normal focus:outline-none" id="borrow-amount-2" placeholder="Set your desired amount" type="text" />
                        </div>
                        <label className="font-semibold text-gray-800 text-sm" for="repayment-amount-2">
                            Set Repayment Amount
                        </label>
                        <input className="border border-gray-300 rounded-md px-4 py-2 text-gray-700 text-sm font-normal focus:outline-none" id="repayment-amount-2" placeholder="Must be more than Borrowed Amount..." type="text" />
                        <label className="font-semibold text-gray-800 text-sm">
                            Repayment Date
                        </label>
                        <div className="flex gap-3">
                            <button className="bg-[#D6E1FF] text-[#1E56FF] font-semibold rounded-md px-5 py-2 text-sm select-none" type="button">
                                5 Days
                            </button>
                            <input className="flex-1 border border-gray-300 rounded-md px-4 py-2 text-gray-700 text-sm font-normal focus:outline-none" placeholder="DD/MM/YY" type="text" />
                            <button aria-label="Calendar" className="flex items-center justify-center border border-gray-300 rounded-md px-3 text-gray-700" type="button">
                                <i className="far fa-calendar-alt">
                                </i>
                            </button>
                        </div>
                        <label className="font-semibold text-gray-800 text-sm" for="reason-2">
                            Reason for Borrowing
                        </label>
                        <textarea className="border border-gray-300 rounded-md px-4 py-2 text-gray-700 text-sm font-normal resize-none focus:outline-none" id="reason-2" maxlength="40" placeholder="My car broke down I need help..." rows="4"></textarea>
                        <div className="text-right text-xs text-gray-400 font-normal select-none">
                            0 / 40
                        </div>
                        <button className="bg-gray-400 text-white font-extrabold text-sm rounded-md py-3 mt-2 w-full cursor-not-allowed" disabled="" type="submit">
                            Make Your Request
                        </button>
                    </form>
                </section>
            </div>}
            {showPurple && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <button onClick={() => setShowPurple(false)} className="text-gray-600 hover:text-gray-800 fixed top-4 right-4 z-50">
                    ✖
                </button>
                <section className="max-w-md mx-auto rounded-lg shadow-md" style={{minWidth: "320px", aspectRatio: "9 / 16"}}>
                    <div className="w-full h-full rounded-lg bg-gradient-to-tr from-[#7B5FFF] via-[#C55FFF] to-[#D45FFF] flex items-center justify-center">
                        <div aria-hidden="true" className="bg-white rounded-full p-6 flex items-center justify-center" style={{width: "72px", height: "72px"}}>
                            <i className="fas fa-check text-[#7B5FFF] text-4xl">
                            </i>
                        </div>
                    </div>
                </section>
            </div>}
        </>
    );
}
